/* tslint:disable */
/* eslint-disable */
/**
 * Bank Backoffice Gateway, Transactions
 * Partner\'s Bank Backoffice Gateway for Transactions
 *
 * The version of the OpenAPI document: 10.0
 * Contact: viktor.dite@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccountBalanceV10
 */
export interface AccountBalanceV10 {
    /**
     * 
     * @type {string}
     * @memberof AccountBalanceV10
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof AccountBalanceV10
     */
    'availableBalance': number;
    /**
     * 
     * @type {number}
     * @memberof AccountBalanceV10
     */
    'availableBalanceWithoutCardHolds': number;
    /**
     * 
     * @type {string}
     * @memberof AccountBalanceV10
     */
    'currencyCode': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AccountNumberTypeV10 = {
    IBAN: 'IBAN',
    ABA: 'ABA',
    SORT_CODE: 'SORT_CODE',
    OTHER: 'OTHER'
} as const;

export type AccountNumberTypeV10 = typeof AccountNumberTypeV10[keyof typeof AccountNumberTypeV10];


/**
 * 
 * @export
 * @interface AmountIsoCurrencyV2x4
 */
export interface AmountIsoCurrencyV2x4 {
    /**
     * 
     * @type {number}
     * @memberof AmountIsoCurrencyV2x4
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof AmountIsoCurrencyV2x4
     */
    'currencyCode': string;
}
/**
 * 
 * @export
 * @interface BankDetailsV10
 */
export interface BankDetailsV10 {
    /**
     * 
     * @type {string}
     * @memberof BankDetailsV10
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankDetailsV10
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankDetailsV10
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankDetailsV10
     */
    'bicSwift'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankDetailsV10
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface CardDetailV10
 */
export interface CardDetailV10 {
    /**
     * 
     * @type {string}
     * @memberof CardDetailV10
     */
    'bankCardUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CardDetailV10
     */
    'pan': string;
}
/**
 * 
 * @export
 * @interface CardInfoV10
 */
export interface CardInfoV10 {
    /**
     * 
     * @type {CardDetailV10}
     * @memberof CardInfoV10
     */
    'card'?: CardDetailV10;
}
/**
 * 
 * @export
 * @interface CardV10
 */
export interface CardV10 {
    /**
     * 
     * @type {AmountIsoCurrencyV2x4}
     * @memberof CardV10
     */
    'cashBack'?: AmountIsoCurrencyV2x4;
    /**
     * 
     * @type {CardDetailV10}
     * @memberof CardV10
     */
    'card'?: CardDetailV10;
}
/**
 * 
 * @export
 * @interface CounterpartyDetailsV10
 */
export interface CounterpartyDetailsV10 {
    /**
     * 
     * @type {PersonDetailsV10}
     * @memberof CounterpartyDetailsV10
     */
    'data'?: PersonDetailsV10;
    /**
     * 
     * @type {BankDetailsV10}
     * @memberof CounterpartyDetailsV10
     */
    'bankDetails'?: BankDetailsV10;
    /**
     * 
     * @type {string}
     * @memberof CounterpartyDetailsV10
     */
    'bankCode'?: string;
}
/**
 * 
 * @export
 * @interface CounterpartyV10
 */
export interface CounterpartyV10 {
    /**
     * 
     * @type {string}
     * @memberof CounterpartyV10
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounterpartyV10
     */
    'logoUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounterpartyV10
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounterpartyV10
     */
    'iban'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounterpartyV10
     */
    'originalName'?: string;
    /**
     * Account name from global account name registry. Null when not found.
     * @type {string}
     * @memberof CounterpartyV10
     */
    'globalName'?: string;
}
/**
 * 
 * @export
 * @interface CurrencyExchangeV10
 */
export interface CurrencyExchangeV10 {
    /**
     * 
     * @type {AmountIsoCurrencyV2x4}
     * @memberof CurrencyExchangeV10
     */
    'sourceAmount'?: AmountIsoCurrencyV2x4;
    /**
     * 
     * @type {number}
     * @memberof CurrencyExchangeV10
     */
    'exchangeRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof CurrencyExchangeV10
     */
    'ecbDeviation'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DirectionV10 = {
    INCOMING: 'INCOMING',
    OUTGOING: 'OUTGOING'
} as const;

export type DirectionV10 = typeof DirectionV10[keyof typeof DirectionV10];


/**
 * 
 * @export
 * @enum {string}
 */

export const EntityTypeV10 = {
    COMPANY: 'COMPANY',
    INDIVIDUAL: 'INDIVIDUAL'
} as const;

export type EntityTypeV10 = typeof EntityTypeV10[keyof typeof EntityTypeV10];


/**
 * 
 * @export
 * @interface FutureTransactionDetailV10
 */
export interface FutureTransactionDetailV10 {
    /**
     * 
     * @type {string}
     * @memberof FutureTransactionDetailV10
     */
    'transactionUuid': string;
    /**
     * 
     * @type {string}
     * @memberof FutureTransactionDetailV10
     */
    'transactionTimestamp': string;
    /**
     * 
     * @type {AmountIsoCurrencyV2x4}
     * @memberof FutureTransactionDetailV10
     */
    'amount': AmountIsoCurrencyV2x4;
    /**
     * 
     * @type {PaymentTypeV10}
     * @memberof FutureTransactionDetailV10
     */
    'paymentType': PaymentTypeV10;
    /**
     * 
     * @type {TransactionStatusV10}
     * @memberof FutureTransactionDetailV10
     */
    'status': TransactionStatusV10;
    /**
     * 
     * @type {CounterpartyV10}
     * @memberof FutureTransactionDetailV10
     */
    'counterparty': CounterpartyV10;
    /**
     * 
     * @type {TransactionStandingOrderV10}
     * @memberof FutureTransactionDetailV10
     */
    'standingOrder'?: TransactionStandingOrderV10;
    /**
     * 
     * @type {string}
     * @memberof FutureTransactionDetailV10
     */
    'note'?: string;
    /**
     * 
     * @type {PaymentCodesV10}
     * @memberof FutureTransactionDetailV10
     */
    'paymentCodes': PaymentCodesV10;
    /**
     * 
     * @type {ValidityV10}
     * @memberof FutureTransactionDetailV10
     */
    'validity': ValidityV10;
    /**
     * 
     * @type {DirectionV10}
     * @memberof FutureTransactionDetailV10
     */
    'direction': DirectionV10;
    /**
     * 
     * @type {string}
     * @memberof FutureTransactionDetailV10
     */
    'paymentReference'?: string;
    /**
     * 
     * @type {string}
     * @memberof FutureTransactionDetailV10
     */
    'accountCurrencyCode': string;
}


/**
 * 
 * @export
 * @interface FutureTransactionInfoV10
 */
export interface FutureTransactionInfoV10 {
    /**
     * 
     * @type {string}
     * @memberof FutureTransactionInfoV10
     */
    'transactionUuid': string;
    /**
     * 
     * @type {string}
     * @memberof FutureTransactionInfoV10
     */
    'transactionTimestamp': string;
    /**
     * 
     * @type {AmountIsoCurrencyV2x4}
     * @memberof FutureTransactionInfoV10
     */
    'amount': AmountIsoCurrencyV2x4;
    /**
     * 
     * @type {PaymentTypeV10}
     * @memberof FutureTransactionInfoV10
     */
    'paymentType': PaymentTypeV10;
    /**
     * 
     * @type {CounterpartyV10}
     * @memberof FutureTransactionInfoV10
     */
    'counterparty': CounterpartyV10;
    /**
     * 
     * @type {DirectionV10}
     * @memberof FutureTransactionInfoV10
     */
    'direction': DirectionV10;
    /**
     * 
     * @type {string}
     * @memberof FutureTransactionInfoV10
     */
    'standingOrderName'?: string;
    /**
     * 
     * @type {string}
     * @memberof FutureTransactionInfoV10
     */
    'accountCurrencyCode': string;
}


/**
 * 
 * @export
 * @interface GetTransactionRequestV10
 */
export interface GetTransactionRequestV10 {
    /**
     * 
     * @type {string}
     * @memberof GetTransactionRequestV10
     */
    'accountUuid': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const InternalCategoryV10 = {
    GROCERIES: 'GROCERIES',
    RESTAURANT: 'RESTAURANT',
    HEALTH_BEAUTY: 'HEALTH_BEAUTY',
    TRANSPORTATION: 'TRANSPORTATION',
    VACATION: 'VACATION',
    ENTERTAINMENT: 'ENTERTAINMENT',
    EDUCATION: 'EDUCATION',
    SERVICES: 'SERVICES',
    DIGITAL_SUBSCRIPTIONS: 'DIGITAL_SUBSCRIPTIONS',
    FASHION: 'FASHION',
    HOUSE_GARDEN: 'HOUSE_GARDEN',
    ATM: 'ATM',
    VICE: 'VICE',
    NONLIFE_INSURANCE: 'NONLIFE_INSURANCE',
    ENERGY: 'ENERGY',
    HOUSEHOLD_FEES: 'HOUSEHOLD_FEES',
    MORTGAGE: 'MORTGAGE',
    RENT: 'RENT',
    HOUSEHOLD_OTHER: 'HOUSEHOLD_OTHER',
    INVESTMENT: 'INVESTMENT',
    RETIREMENT_SAVINGS: 'RETIREMENT_SAVINGS',
    BUILDING_SAVINGS: 'BUILDING_SAVINGS',
    INVESTMENTS_OTHER: 'INVESTMENTS_OTHER',
    LIFE_INSURANCE: 'LIFE_INSURANCE',
    SHORT_TIME_RESERVE: 'SHORT_TIME_RESERVE',
    SHORT_TIME_OTHER: 'SHORT_TIME_OTHER',
    CONSUMPTION_OTHER: 'CONSUMPTION_OTHER'
} as const;

export type InternalCategoryV10 = typeof InternalCategoryV10[keyof typeof InternalCategoryV10];


/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV1x0
 */
export interface PageableResponseV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV1x0
 */
export interface PageableV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @interface PaymentCodesV10
 */
export interface PaymentCodesV10 {
    /**
     * Constant symbol
     * @type {string}
     * @memberof PaymentCodesV10
     */
    'constant'?: string;
    /**
     * Specific symbol
     * @type {string}
     * @memberof PaymentCodesV10
     */
    'specific'?: string;
    /**
     * Variable symbol
     * @type {string}
     * @memberof PaymentCodesV10
     */
    'variable'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentTypeV10 = {
    TRANSFER: 'TRANSFER',
    INSTANT_PAYMENT: 'INSTANT_PAYMENT',
    CARD_ACCOUNT_FUNDING: 'CARD_ACCOUNT_FUNDING',
    CARD_PAYMENT: 'CARD_PAYMENT',
    CARD_PAYMENT_SUPER_SAVINGS_ACCOUNT: 'CARD_PAYMENT_SUPER_SAVINGS_ACCOUNT',
    CARD_WITHDRAWAL: 'CARD_WITHDRAWAL',
    CARD_CASH_ADVANCE: 'CARD_CASH_ADVANCE',
    CARD_MONEY_TRANSFER: 'CARD_MONEY_TRANSFER',
    CARD_CASHBACK: 'CARD_CASHBACK',
    CARD_RETURN: 'CARD_RETURN',
    CARD_REFUND: 'CARD_REFUND',
    STANDING_ORDER: 'STANDING_ORDER',
    DIRECT_DEBIT: 'DIRECT_DEBIT',
    SIPO: 'SIPO',
    WITHHOLDING_TAX: 'WITHHOLDING_TAX',
    NEGATIVE_INTEREST_CORRECTION: 'NEGATIVE_INTEREST_CORRECTION',
    NEGATIVE_INTEREST: 'NEGATIVE_INTEREST',
    POSITIVE_INTEREST_CORRECTION: 'POSITIVE_INTEREST_CORRECTION',
    POSITIVE_INTEREST: 'POSITIVE_INTEREST',
    PRODUCT_PACKAGE_FEE: 'PRODUCT_PACKAGE_FEE',
    INSTALMENT: 'INSTALMENT',
    HOLD_FAU_OFFICE: 'HOLD_FAU_OFFICE',
    HOLD_EXECUTION: 'HOLD_EXECUTION',
    HOLD_POLICE: 'HOLD_POLICE',
    HOLD_RISK_AML: 'HOLD_RISK_AML',
    HOLD_LIVING_WAGE: 'HOLD_LIVING_WAGE',
    HOLD_SETTLEMENT: 'HOLD_SETTLEMENT',
    SEPA_TRANSFER: 'SEPA_TRANSFER',
    SWEEP: 'SWEEP',
    ONE_TIME_FEE: 'ONE_TIME_FEE',
    ZPS_TRANSFER: 'ZPS_TRANSFER',
    ZPS_FEE: 'ZPS_FEE',
    EXCHANGE: 'EXCHANGE',
    TRANSFER_CONVERSION: 'TRANSFER_CONVERSION',
    BALANCE_REALIGNMENT: 'BALANCE_REALIGNMENT',
    BANK_INSURANCE_FEE: 'BANK_INSURANCE_FEE',
    CRYPTO_ASSETS_PURCHASE: 'CRYPTO_ASSETS_PURCHASE',
    CRYPTO_ASSETS_SALE: 'CRYPTO_ASSETS_SALE',
    CRYPTO_ASSETS_PURCHASE_FEE: 'CRYPTO_ASSETS_PURCHASE_FEE',
    CRYPTO_ASSETS_SALE_FEE: 'CRYPTO_ASSETS_SALE_FEE',
    TD_INIT_PAYMENT: 'TD_INIT_PAYMENT',
    TD_FINAL_TRANSFER: 'TD_FINAL_TRANSFER'
} as const;

export type PaymentTypeV10 = typeof PaymentTypeV10[keyof typeof PaymentTypeV10];


/**
 * 
 * @export
 * @interface PersonDetailsV10
 */
export interface PersonDetailsV10 {
    /**
     * 
     * @type {string}
     * @memberof PersonDetailsV10
     */
    'beneficiaryId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonDetailsV10
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonDetailsV10
     */
    'country'?: string;
    /**
     * 
     * @type {EntityTypeV10}
     * @memberof PersonDetailsV10
     */
    'entityType'?: EntityTypeV10;
    /**
     * 
     * @type {string}
     * @memberof PersonDetailsV10
     */
    'companyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonDetailsV10
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonDetailsV10
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonDetailsV10
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonDetailsV10
     */
    'postcode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonDetailsV10
     */
    'stateOrProvince'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonDetailsV10
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {AccountNumberTypeV10}
     * @memberof PersonDetailsV10
     */
    'accountNumberType'?: AccountNumberTypeV10;
}


/**
 * 
 * @export
 * @interface PosDataV10
 */
export interface PosDataV10 {
    /**
     * Indicates if the card was physically present during the transaction
     * @type {boolean}
     * @memberof PosDataV10
     */
    'cardPresent'?: boolean;
}
/**
 * 
 * @export
 * @interface RealizedTransactionDetailV10
 */
export interface RealizedTransactionDetailV10 {
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionDetailV10
     */
    'transactionUuid': string;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionDetailV10
     */
    'transactionTimestamp': string;
    /**
     * 
     * @type {AmountIsoCurrencyV2x4}
     * @memberof RealizedTransactionDetailV10
     */
    'amount': AmountIsoCurrencyV2x4;
    /**
     * 
     * @type {DirectionV10}
     * @memberof RealizedTransactionDetailV10
     */
    'direction': DirectionV10;
    /**
     * 
     * @type {PaymentTypeV10}
     * @memberof RealizedTransactionDetailV10
     */
    'paymentType': PaymentTypeV10;
    /**
     * 
     * @type {TransactionInfoSourceV10}
     * @memberof RealizedTransactionDetailV10
     */
    'transactionInfoSource': TransactionInfoSourceV10;
    /**
     * 
     * @type {TransactionStatusV10}
     * @memberof RealizedTransactionDetailV10
     */
    'status': TransactionStatusV10;
    /**
     * 
     * @type {CounterpartyV10}
     * @memberof RealizedTransactionDetailV10
     */
    'counterparty': CounterpartyV10;
    /**
     * 
     * @type {TransactionDirectDebitV10}
     * @memberof RealizedTransactionDetailV10
     */
    'directDebit'?: TransactionDirectDebitV10;
    /**
     * 
     * @type {TransactionStandingOrderV10}
     * @memberof RealizedTransactionDetailV10
     */
    'standingOrder'?: TransactionStandingOrderV10;
    /**
     * 
     * @type {TransactionSipoV10}
     * @memberof RealizedTransactionDetailV10
     */
    'sipo'?: TransactionSipoV10;
    /**
     * 
     * @type {CurrencyExchangeV10}
     * @memberof RealizedTransactionDetailV10
     */
    'currencyExchange'?: CurrencyExchangeV10;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionDetailV10
     */
    'note'?: string;
    /**
     * 
     * @type {PaymentCodesV10}
     * @memberof RealizedTransactionDetailV10
     */
    'paymentCodes': PaymentCodesV10;
    /**
     * 
     * @type {CardV10}
     * @memberof RealizedTransactionDetailV10
     */
    'card'?: CardV10;
    /**
     * 
     * @type {PosDataV10}
     * @memberof RealizedTransactionDetailV10
     */
    'posData'?: PosDataV10;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionDetailV10
     */
    'valutaDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionDetailV10
     */
    'realizationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionDetailV10
     */
    'expirationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionDetailV10
     */
    'rejectedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionDetailV10
     */
    'reversalDate'?: string;
    /**
     * 
     * @type {TransactionStatusReasonV10}
     * @memberof RealizedTransactionDetailV10
     */
    'statusReason'?: TransactionStatusReasonV10;
    /**
     * 
     * @type {TransactionActionsV10}
     * @memberof RealizedTransactionDetailV10
     */
    'actions': TransactionActionsV10;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionDetailV10
     */
    'shortTransactionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealizedTransactionDetailV10
     */
    'requiredTransactionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionDetailV10
     */
    'paymentReference'?: string;
    /**
     * 
     * @type {AccountBalanceV10}
     * @memberof RealizedTransactionDetailV10
     */
    'accountBalance'?: AccountBalanceV10;
    /**
     * 
     * @type {InternalCategoryV10}
     * @memberof RealizedTransactionDetailV10
     */
    'internalCategory'?: InternalCategoryV10;
    /**
     * PID UUID of the user who signed the transaction.
     * @type {string}
     * @memberof RealizedTransactionDetailV10
     */
    'creatorPidUuid'?: string;
    /**
     * Defines the channel of the transaction request.
     * @type {string}
     * @memberof RealizedTransactionDetailV10
     */
    'requestedOperation'?: string;
    /**
     * Chosen date to process the transaction (due date).
     * @type {string}
     * @memberof RealizedTransactionDetailV10
     */
    'validFrom'?: string;
    /**
     * When the transaction was signed.
     * @type {string}
     * @memberof RealizedTransactionDetailV10
     */
    'signedTimestamp'?: string;
    /**
     * 
     * @type {CounterpartyDetailsV10}
     * @memberof RealizedTransactionDetailV10
     */
    'counterpartyDetails'?: CounterpartyDetailsV10;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionDetailV10
     */
    'accountCurrencyCode': string;
}


/**
 * 
 * @export
 * @interface RealizedTransactionInfoV10
 */
export interface RealizedTransactionInfoV10 {
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionInfoV10
     */
    'transactionUuid': string;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionInfoV10
     */
    'transactionTimestamp': string;
    /**
     * 
     * @type {AmountIsoCurrencyV2x4}
     * @memberof RealizedTransactionInfoV10
     */
    'amount': AmountIsoCurrencyV2x4;
    /**
     * 
     * @type {CurrencyExchangeV10}
     * @memberof RealizedTransactionInfoV10
     */
    'currencyExchange'?: CurrencyExchangeV10;
    /**
     * 
     * @type {TransactionStatusV10}
     * @memberof RealizedTransactionInfoV10
     */
    'status': TransactionStatusV10;
    /**
     * 
     * @type {DirectionV10}
     * @memberof RealizedTransactionInfoV10
     */
    'direction': DirectionV10;
    /**
     * 
     * @type {PaymentTypeV10}
     * @memberof RealizedTransactionInfoV10
     */
    'paymentType': PaymentTypeV10;
    /**
     * 
     * @type {TransactionInfoSourceV10}
     * @memberof RealizedTransactionInfoV10
     */
    'transactionInfoSource': TransactionInfoSourceV10;
    /**
     * 
     * @type {CounterpartyV10}
     * @memberof RealizedTransactionInfoV10
     */
    'counterparty': CounterpartyV10;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionInfoV10
     */
    'shortTransactionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionInfoV10
     */
    'standingOrderName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionInfoV10
     */
    'sipoName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionInfoV10
     */
    'directDebitName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionInfoV10
     */
    'note'?: string;
    /**
     * 
     * @type {PaymentCodesV10}
     * @memberof RealizedTransactionInfoV10
     */
    'paymentCodes': PaymentCodesV10;
    /**
     * 
     * @type {boolean}
     * @memberof RealizedTransactionInfoV10
     */
    'isTokenTransaction'?: boolean;
    /**
     * 
     * @type {WalletTypeV10}
     * @memberof RealizedTransactionInfoV10
     */
    'walletType'?: WalletTypeV10;
    /**
     * 
     * @type {number}
     * @memberof RealizedTransactionInfoV10
     */
    'requiredTransactionId'?: number;
    /**
     * 
     * @type {AccountBalanceV10}
     * @memberof RealizedTransactionInfoV10
     */
    'accountBalance'?: AccountBalanceV10;
    /**
     * 
     * @type {InternalCategoryV10}
     * @memberof RealizedTransactionInfoV10
     */
    'internalCategory'?: InternalCategoryV10;
    /**
     * 
     * @type {CardInfoV10}
     * @memberof RealizedTransactionInfoV10
     */
    'card'?: CardInfoV10;
    /**
     * 
     * @type {string}
     * @memberof RealizedTransactionInfoV10
     */
    'accountCurrencyCode': string;
}


/**
 * 
 * @export
 * @interface SearchFutureTransactionsFilterV10
 */
export interface SearchFutureTransactionsFilterV10 {
    /**
     * 
     * @type {string}
     * @memberof SearchFutureTransactionsFilterV10
     */
    'standingOrderUuid'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchFutureTransactionsFilterV10
     */
    'accountCurrencyCode'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SearchFutureTransactionsRequestV10
 */
export interface SearchFutureTransactionsRequestV10 {
    /**
     * 
     * @type {string}
     * @memberof SearchFutureTransactionsRequestV10
     */
    'accountUuid': string;
    /**
     * 
     * @type {SearchFutureTransactionsFilterV10}
     * @memberof SearchFutureTransactionsRequestV10
     */
    'filter'?: SearchFutureTransactionsFilterV10;
    /**
     * 
     * @type {PageableV1x0}
     * @memberof SearchFutureTransactionsRequestV10
     */
    'pageable': PageableV1x0;
}
/**
 * 
 * @export
 * @interface SearchFutureTransactionsResponseV10
 */
export interface SearchFutureTransactionsResponseV10 {
    /**
     * 
     * @type {Array<FutureTransactionInfoV10>}
     * @memberof SearchFutureTransactionsResponseV10
     */
    'transactions': Array<FutureTransactionInfoV10>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof SearchFutureTransactionsResponseV10
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface SearchRealizedTransactionsFilterV10
 */
export interface SearchRealizedTransactionsFilterV10 {
    /**
     * 
     * @type {SearchRealizedTransactionsFilterV10AmountInterval}
     * @memberof SearchRealizedTransactionsFilterV10
     */
    'amountInterval'?: SearchRealizedTransactionsFilterV10AmountInterval;
    /**
     * 
     * @type {string}
     * @memberof SearchRealizedTransactionsFilterV10
     */
    'bankCardUuid'?: string;
    /**
     * 
     * @type {DirectionV10}
     * @memberof SearchRealizedTransactionsFilterV10
     */
    'direction'?: DirectionV10;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchRealizedTransactionsFilterV10
     */
    'fullText'?: Array<string>;
    /**
     * 
     * @type {Array<PaymentTypeV10>}
     * @memberof SearchRealizedTransactionsFilterV10
     */
    'paymentType'?: Array<PaymentTypeV10>;
    /**
     * 
     * @type {string}
     * @memberof SearchRealizedTransactionsFilterV10
     */
    'standingOrderUuid'?: string;
    /**
     * 
     * @type {Array<TransactionStatusV10>}
     * @memberof SearchRealizedTransactionsFilterV10
     */
    'status'?: Array<TransactionStatusV10>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchRealizedTransactionsFilterV10
     */
    'accountCurrencyCode'?: Array<string>;
    /**
     * 
     * @type {SearchRealizedTransactionsFilterV10TransactionTimestampInterval}
     * @memberof SearchRealizedTransactionsFilterV10
     */
    'transactionTimestampInterval'?: SearchRealizedTransactionsFilterV10TransactionTimestampInterval;
}


/**
 * Closed interval of amount
 * @export
 * @interface SearchRealizedTransactionsFilterV10AmountInterval
 */
export interface SearchRealizedTransactionsFilterV10AmountInterval {
    /**
     * 
     * @type {AmountIsoCurrencyV2x4}
     * @memberof SearchRealizedTransactionsFilterV10AmountInterval
     */
    'from'?: AmountIsoCurrencyV2x4;
    /**
     * 
     * @type {AmountIsoCurrencyV2x4}
     * @memberof SearchRealizedTransactionsFilterV10AmountInterval
     */
    'to'?: AmountIsoCurrencyV2x4;
}
/**
 * 
 * @export
 * @interface SearchRealizedTransactionsFilterV10TransactionTimestampInterval
 */
export interface SearchRealizedTransactionsFilterV10TransactionTimestampInterval {
    /**
     * 
     * @type {string}
     * @memberof SearchRealizedTransactionsFilterV10TransactionTimestampInterval
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchRealizedTransactionsFilterV10TransactionTimestampInterval
     */
    'to'?: string;
}
/**
 * 
 * @export
 * @interface SearchRealizedTransactionsRequestV10
 */
export interface SearchRealizedTransactionsRequestV10 {
    /**
     * 
     * @type {string}
     * @memberof SearchRealizedTransactionsRequestV10
     */
    'accountUuid': string;
    /**
     * 
     * @type {SearchRealizedTransactionsFilterV10}
     * @memberof SearchRealizedTransactionsRequestV10
     */
    'filter'?: SearchRealizedTransactionsFilterV10;
    /**
     * 
     * @type {PageableV1x0}
     * @memberof SearchRealizedTransactionsRequestV10
     */
    'pageable': PageableV1x0;
}
/**
 * 
 * @export
 * @interface SearchRealizedTransactionsResponseV10
 */
export interface SearchRealizedTransactionsResponseV10 {
    /**
     * 
     * @type {Array<RealizedTransactionInfoV10>}
     * @memberof SearchRealizedTransactionsResponseV10
     */
    'transactions': Array<RealizedTransactionInfoV10>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof SearchRealizedTransactionsResponseV10
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface TransactionActionsV10
 */
export interface TransactionActionsV10 {
    /**
     * 
     * @type {boolean}
     * @memberof TransactionActionsV10
     */
    'repeat': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionActionsV10
     */
    'reply': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionActionsV10
     */
    'createTemplate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionActionsV10
     */
    'createStandingOrder': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionActionsV10
     */
    'getConfirmation': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionActionsV10
     */
    'getDetailDirectDebit': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionActionsV10
     */
    'getDetailStandingOrder': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionActionsV10
     */
    'getDetailSipo': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionActionsV10
     */
    'createComplaint': boolean;
}
/**
 * 
 * @export
 * @interface TransactionDirectDebitV10
 */
export interface TransactionDirectDebitV10 {
    /**
     * 
     * @type {string}
     * @memberof TransactionDirectDebitV10
     */
    'directDebitUuid': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDirectDebitV10
     */
    'name': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TransactionInfoSourceV10 = {
    REALIZED: 'REALIZED',
    REQUIRED: 'REQUIRED',
    PLANNED: 'PLANNED',
    CARD_HOLD: 'CARD_HOLD',
    DECLINED_CARD_TRANSACTION: 'DECLINED_CARD_TRANSACTION'
} as const;

export type TransactionInfoSourceV10 = typeof TransactionInfoSourceV10[keyof typeof TransactionInfoSourceV10];


/**
 * 
 * @export
 * @interface TransactionSipoV10
 */
export interface TransactionSipoV10 {
    /**
     * 
     * @type {string}
     * @memberof TransactionSipoV10
     */
    'sipoUuid': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionSipoV10
     */
    'connectionNumber': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionSipoV10
     */
    'sipoName'?: string;
}
/**
 * 
 * @export
 * @interface TransactionStandingOrderV10
 */
export interface TransactionStandingOrderV10 {
    /**
     * 
     * @type {string}
     * @memberof TransactionStandingOrderV10
     */
    'standingOrderUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionStandingOrderV10
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TransactionStatusReasonV10 = {
    DECLINED_FROZEN_CARD: 'DECLINED_FROZEN_CARD',
    DECLINED_TERMINATED_CARD: 'DECLINED_TERMINATED_CARD',
    DECLINED_ATM_DISABLED: 'DECLINED_ATM_DISABLED',
    DECLINED_CONTACTLESS_DISABLED: 'DECLINED_CONTACTLESS_DISABLED',
    DECLINED_ECOMMERCE_DISABLED: 'DECLINED_ECOMMERCE_DISABLED',
    DECLINED_MAG_STRIPE_DISABLED: 'DECLINED_MAG_STRIPE_DISABLED',
    DECLINED_MCC_BLOCKED: 'DECLINED_MCC_BLOCKED',
    DECLINED_DAILY_LIMIT_EXCEEDED: 'DECLINED_DAILY_LIMIT_EXCEEDED',
    DECLINED_MAXIMAL_LIMIT_EXCEEDED: 'DECLINED_MAXIMAL_LIMIT_EXCEEDED',
    DECLINED_UNACTIVATED_CARD: 'DECLINED_UNACTIVATED_CARD',
    DECLINED_CASH_BACK_IN_FOREIGN_CURRENCY: 'DECLINED_CASH_BACK_IN_FOREIGN_CURRENCY',
    DECLINED_DCC_BLOCKED: 'DECLINED_DCC_BLOCKED',
    DECLINED_INSUFFICIENT_FOUNDS: 'DECLINED_INSUFFICIENT_FOUNDS',
    DECLINED_FRAUD_DETECTION: 'DECLINED_FRAUD_DETECTION',
    DECLINED_UNEXPECTED_PROBLEM: 'DECLINED_UNEXPECTED_PROBLEM',
    DECLINED_SOFT_DECLINE: 'DECLINED_SOFT_DECLINE',
    EXPIRED_CARD_HOLD: 'EXPIRED_CARD_HOLD',
    EXPIRED_INSUFFICIENT_BALANCE: 'EXPIRED_INSUFFICIENT_BALANCE',
    REJECTED_FRAUD_DETECTION: 'REJECTED_FRAUD_DETECTION',
    EXPIRED: 'EXPIRED',
    REVERTED: 'REVERTED',
    MANUALLY_RELEASED: 'MANUALLY_RELEASED',
    DISTRAINT_TERMINATION: 'DISTRAINT_TERMINATION',
    INVALID_CVV2: 'INVALID_CVV2',
    INVALID_EXPIRATION_DATE: 'INVALID_EXPIRATION_DATE',
    INVALID_PIN: 'INVALID_PIN',
    PIN_NOT_ASSIGNED: 'PIN_NOT_ASSIGNED',
    DECLINED_FRAUD_INVESTIGATION: 'DECLINED_FRAUD_INVESTIGATION',
    UNKNOWN: 'UNKNOWN'
} as const;

export type TransactionStatusReasonV10 = typeof TransactionStatusReasonV10[keyof typeof TransactionStatusReasonV10];


/**
 * 
 * @export
 * @enum {string}
 */

export const TransactionStatusV10 = {
    CANCELLED_BY_BANK: 'CANCELLED_BY_BANK',
    HOLDED: 'HOLDED',
    PARTIAL_REALIZED: 'PARTIAL_REALIZED',
    READY_FOR_REALIZATION: 'READY_FOR_REALIZATION',
    REALIZED: 'REALIZED',
    REVERTED: 'REVERTED',
    CANCELLED_BY_CLIENT: 'CANCELLED_BY_CLIENT',
    EXPIRED: 'EXPIRED',
    REJECTED: 'REJECTED',
    MANUALLY_RELEASED: 'MANUALLY_RELEASED'
} as const;

export type TransactionStatusV10 = typeof TransactionStatusV10[keyof typeof TransactionStatusV10];


/**
 * 
 * @export
 * @interface ValidityV10
 */
export interface ValidityV10 {
    /**
     * 
     * @type {string}
     * @memberof ValidityV10
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ValidityV10
     */
    'validTo'?: string;
}
/**
 * Wallet types. * APPLE_PAY * GOOGLE_PAY * GARMIN_PAY * FIDESMO_PAY * SWATCH_PAY * CLICK_TO_PAY * OTHER 
 * @export
 * @enum {string}
 */

export const WalletTypeV10 = {
    APPLE_PAY: 'APPLE_PAY',
    GOOGLE_PAY: 'GOOGLE_PAY',
    GARMIN_PAY: 'GARMIN_PAY',
    FIDESMO_PAY: 'FIDESMO_PAY',
    SWATCH_PAY: 'SWATCH_PAY',
    CLICK_TO_PAY: 'CLICK_TO_PAY',
    OTHER: 'OTHER'
} as const;

export type WalletTypeV10 = typeof WalletTypeV10[keyof typeof WalletTypeV10];




/**
 * FutureTransactionsApi - axios parameter creator
 * @export
 */
export const FutureTransactionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get future transaction by transaction uuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} transactionUuid Transaction UUID
         * @param {GetTransactionRequestV10} getTransactionRequestV10 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFutureTransactionDetailV10: async (xCorrelationId: string, transactionUuid: string, getTransactionRequestV10: GetTransactionRequestV10, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getFutureTransactionDetailV10', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'transactionUuid' is not null or undefined
            assertParamExists('getFutureTransactionDetailV10', 'transactionUuid', transactionUuid)
            // verify required parameter 'getTransactionRequestV10' is not null or undefined
            assertParamExists('getFutureTransactionDetailV10', 'getTransactionRequestV10', getTransactionRequestV10)
            const localVarPath = `/bank-backofficegateway-transactions/v10/future-transactions/{transactionUuid}`
                .replace(`{${"transactionUuid"}}`, encodeURIComponent(String(transactionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getTransactionRequestV10, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search future transactions by specified filter.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SearchFutureTransactionsRequestV10} searchFutureTransactionsRequestV10 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFutureTransactionsV10: async (xCorrelationId: string, searchFutureTransactionsRequestV10: SearchFutureTransactionsRequestV10, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('searchFutureTransactionsV10', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'searchFutureTransactionsRequestV10' is not null or undefined
            assertParamExists('searchFutureTransactionsV10', 'searchFutureTransactionsRequestV10', searchFutureTransactionsRequestV10)
            const localVarPath = `/bank-backofficegateway-transactions/v10/future-transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchFutureTransactionsRequestV10, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FutureTransactionsApi - functional programming interface
 * @export
 */
export const FutureTransactionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FutureTransactionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get future transaction by transaction uuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} transactionUuid Transaction UUID
         * @param {GetTransactionRequestV10} getTransactionRequestV10 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFutureTransactionDetailV10(xCorrelationId: string, transactionUuid: string, getTransactionRequestV10: GetTransactionRequestV10, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FutureTransactionDetailV10>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFutureTransactionDetailV10(xCorrelationId, transactionUuid, getTransactionRequestV10, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search future transactions by specified filter.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SearchFutureTransactionsRequestV10} searchFutureTransactionsRequestV10 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFutureTransactionsV10(xCorrelationId: string, searchFutureTransactionsRequestV10: SearchFutureTransactionsRequestV10, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchFutureTransactionsResponseV10>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFutureTransactionsV10(xCorrelationId, searchFutureTransactionsRequestV10, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FutureTransactionsApi - factory interface
 * @export
 */
export const FutureTransactionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FutureTransactionsApiFp(configuration)
    return {
        /**
         * Get future transaction by transaction uuid.
         * @param {FutureTransactionsApiGetFutureTransactionDetailV10Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFutureTransactionDetailV10(requestParameters: FutureTransactionsApiGetFutureTransactionDetailV10Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FutureTransactionDetailV10> {
            return localVarFp.getFutureTransactionDetailV10(requestParameters.xCorrelationId, requestParameters.transactionUuid, requestParameters.getTransactionRequestV10, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Search future transactions by specified filter.
         * @param {FutureTransactionsApiSearchFutureTransactionsV10Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFutureTransactionsV10(requestParameters: FutureTransactionsApiSearchFutureTransactionsV10Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<SearchFutureTransactionsResponseV10> {
            return localVarFp.searchFutureTransactionsV10(requestParameters.xCorrelationId, requestParameters.searchFutureTransactionsRequestV10, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getFutureTransactionDetailV10 operation in FutureTransactionsApi.
 * @export
 * @type FutureTransactionsApiGetFutureTransactionDetailV10Request
 */
export type FutureTransactionsApiGetFutureTransactionDetailV10Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof FutureTransactionsApiGetFutureTransactionDetailV10
     */
    readonly xCorrelationId: string

    /**
     * Transaction UUID
     * @type {string}
     * @memberof FutureTransactionsApiGetFutureTransactionDetailV10
     */
    readonly transactionUuid: string

    /**
     * 
     * @type {GetTransactionRequestV10}
     * @memberof FutureTransactionsApiGetFutureTransactionDetailV10
     */
    readonly getTransactionRequestV10: GetTransactionRequestV10
}

/**
 * Request parameters for searchFutureTransactionsV10 operation in FutureTransactionsApi.
 * @export
 * @type FutureTransactionsApiSearchFutureTransactionsV10Request
 */
export type FutureTransactionsApiSearchFutureTransactionsV10Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof FutureTransactionsApiSearchFutureTransactionsV10
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {SearchFutureTransactionsRequestV10}
     * @memberof FutureTransactionsApiSearchFutureTransactionsV10
     */
    readonly searchFutureTransactionsRequestV10: SearchFutureTransactionsRequestV10
}

/**
 * FutureTransactionsApi - object-oriented interface
 * @export
 * @class FutureTransactionsApi
 * @extends {BaseAPI}
 */
export class FutureTransactionsApi extends BaseAPI {
    /**
     * Get future transaction by transaction uuid.
     * @param {FutureTransactionsApiGetFutureTransactionDetailV10Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FutureTransactionsApi
     */
    public getFutureTransactionDetailV10(requestParameters: FutureTransactionsApiGetFutureTransactionDetailV10Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return FutureTransactionsApiFp(this.configuration).getFutureTransactionDetailV10(requestParameters.xCorrelationId, requestParameters.transactionUuid, requestParameters.getTransactionRequestV10, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search future transactions by specified filter.
     * @param {FutureTransactionsApiSearchFutureTransactionsV10Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FutureTransactionsApi
     */
    public searchFutureTransactionsV10(requestParameters: FutureTransactionsApiSearchFutureTransactionsV10Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return FutureTransactionsApiFp(this.configuration).searchFutureTransactionsV10(requestParameters.xCorrelationId, requestParameters.searchFutureTransactionsRequestV10, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RealizedTransactionsApi - axios parameter creator
 * @export
 */
export const RealizedTransactionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get future transaction by transaction uuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} transactionUuid Transaction UUID
         * @param {GetTransactionRequestV10} getTransactionRequestV10 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealizedTransactionDetailV10: async (xCorrelationId: string, transactionUuid: string, getTransactionRequestV10: GetTransactionRequestV10, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getRealizedTransactionDetailV10', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'transactionUuid' is not null or undefined
            assertParamExists('getRealizedTransactionDetailV10', 'transactionUuid', transactionUuid)
            // verify required parameter 'getTransactionRequestV10' is not null or undefined
            assertParamExists('getRealizedTransactionDetailV10', 'getTransactionRequestV10', getTransactionRequestV10)
            const localVarPath = `/bank-backofficegateway-transactions/v10/realized-transactions/{transactionUuid}`
                .replace(`{${"transactionUuid"}}`, encodeURIComponent(String(transactionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getTransactionRequestV10, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of realized transactions
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SearchRealizedTransactionsRequestV10} searchRealizedTransactionsRequestV10 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRealizedTransactionsV10: async (xCorrelationId: string, searchRealizedTransactionsRequestV10: SearchRealizedTransactionsRequestV10, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('searchRealizedTransactionsV10', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'searchRealizedTransactionsRequestV10' is not null or undefined
            assertParamExists('searchRealizedTransactionsV10', 'searchRealizedTransactionsRequestV10', searchRealizedTransactionsRequestV10)
            const localVarPath = `/bank-backofficegateway-transactions/v10/realized-transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchRealizedTransactionsRequestV10, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RealizedTransactionsApi - functional programming interface
 * @export
 */
export const RealizedTransactionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RealizedTransactionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get future transaction by transaction uuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} transactionUuid Transaction UUID
         * @param {GetTransactionRequestV10} getTransactionRequestV10 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRealizedTransactionDetailV10(xCorrelationId: string, transactionUuid: string, getTransactionRequestV10: GetTransactionRequestV10, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RealizedTransactionDetailV10>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRealizedTransactionDetailV10(xCorrelationId, transactionUuid, getTransactionRequestV10, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of realized transactions
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SearchRealizedTransactionsRequestV10} searchRealizedTransactionsRequestV10 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchRealizedTransactionsV10(xCorrelationId: string, searchRealizedTransactionsRequestV10: SearchRealizedTransactionsRequestV10, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchRealizedTransactionsResponseV10>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchRealizedTransactionsV10(xCorrelationId, searchRealizedTransactionsRequestV10, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RealizedTransactionsApi - factory interface
 * @export
 */
export const RealizedTransactionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RealizedTransactionsApiFp(configuration)
    return {
        /**
         * Get future transaction by transaction uuid.
         * @param {RealizedTransactionsApiGetRealizedTransactionDetailV10Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealizedTransactionDetailV10(requestParameters: RealizedTransactionsApiGetRealizedTransactionDetailV10Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<RealizedTransactionDetailV10> {
            return localVarFp.getRealizedTransactionDetailV10(requestParameters.xCorrelationId, requestParameters.transactionUuid, requestParameters.getTransactionRequestV10, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get list of realized transactions
         * @param {RealizedTransactionsApiSearchRealizedTransactionsV10Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRealizedTransactionsV10(requestParameters: RealizedTransactionsApiSearchRealizedTransactionsV10Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<SearchRealizedTransactionsResponseV10> {
            return localVarFp.searchRealizedTransactionsV10(requestParameters.xCorrelationId, requestParameters.searchRealizedTransactionsRequestV10, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getRealizedTransactionDetailV10 operation in RealizedTransactionsApi.
 * @export
 * @type RealizedTransactionsApiGetRealizedTransactionDetailV10Request
 */
export type RealizedTransactionsApiGetRealizedTransactionDetailV10Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof RealizedTransactionsApiGetRealizedTransactionDetailV10
     */
    readonly xCorrelationId: string

    /**
     * Transaction UUID
     * @type {string}
     * @memberof RealizedTransactionsApiGetRealizedTransactionDetailV10
     */
    readonly transactionUuid: string

    /**
     * 
     * @type {GetTransactionRequestV10}
     * @memberof RealizedTransactionsApiGetRealizedTransactionDetailV10
     */
    readonly getTransactionRequestV10: GetTransactionRequestV10
}

/**
 * Request parameters for searchRealizedTransactionsV10 operation in RealizedTransactionsApi.
 * @export
 * @type RealizedTransactionsApiSearchRealizedTransactionsV10Request
 */
export type RealizedTransactionsApiSearchRealizedTransactionsV10Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof RealizedTransactionsApiSearchRealizedTransactionsV10
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {SearchRealizedTransactionsRequestV10}
     * @memberof RealizedTransactionsApiSearchRealizedTransactionsV10
     */
    readonly searchRealizedTransactionsRequestV10: SearchRealizedTransactionsRequestV10
}

/**
 * RealizedTransactionsApi - object-oriented interface
 * @export
 * @class RealizedTransactionsApi
 * @extends {BaseAPI}
 */
export class RealizedTransactionsApi extends BaseAPI {
    /**
     * Get future transaction by transaction uuid.
     * @param {RealizedTransactionsApiGetRealizedTransactionDetailV10Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RealizedTransactionsApi
     */
    public getRealizedTransactionDetailV10(requestParameters: RealizedTransactionsApiGetRealizedTransactionDetailV10Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return RealizedTransactionsApiFp(this.configuration).getRealizedTransactionDetailV10(requestParameters.xCorrelationId, requestParameters.transactionUuid, requestParameters.getTransactionRequestV10, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of realized transactions
     * @param {RealizedTransactionsApiSearchRealizedTransactionsV10Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RealizedTransactionsApi
     */
    public searchRealizedTransactionsV10(requestParameters: RealizedTransactionsApiSearchRealizedTransactionsV10Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return RealizedTransactionsApiFp(this.configuration).searchRealizedTransactionsV10(requestParameters.xCorrelationId, requestParameters.searchRealizedTransactionsRequestV10, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


